<!--  -->
<template>
  <div class="comments_box">
    <van-pull-refresh v-model="isDownLoading" @refresh="onRefresh">
      <van-list
        v-model="vantList_IsLoading"
        :finished="vantList_IsLoadOver"
        offset="20"
        :finished-text="'我是有底线的'"
        :finish-text="'数据加载完毕'"
        :loading-text="'数据加载中...'"
        @load="onUpRefreshLoad"
      >
        <div class="comments">
          <Comment :module="'archieve'" :id="id" :list="commentslist" />
        </div>
      </van-list>
    </van-pull-refresh>
    <div class="footer_bar">
      <!-- 底部输入区 -->
      <input
        type="text"
        placeholder="欢迎发表你的评论"
        placeholder-style="color:#a7a7a7;"
        @click="handleInput"
        readonly
      />
    </div>
    <van-popup v-model="showPopup" position="bottom" :style="{ height: '25%' }">
      <div class="shuru">
        <van-field
          ref="content"
          v-model="comment"
          rows="3"
          autosize
          type="textarea"
          maxlength="120"
          placeholder="请发表你的留言"
          show-word-limit
        />
        <div class="fasong" @click="handleSubmit">发送</div>
      </div>
    </van-popup>
    <SlideBar />
  </div>
</template>

<script>
import Comment from "@/components/Comment";
import SlideBar from "@/components/SlideBar";
export default {
  components: { Comment, SlideBar },
  data() {
    return {
      commentslist: [],
      page: 1,
      limit: 10,
      id: 0,
      showPopup: false,
      comment: "", //评论
      module: "",
      isDownLoading: false, // 下拉刷新
      vantList_IsLoading: false,
      vantList_IsLoadOver: false,
    };
  },

  computed: {},
  methods: {
    // 查询评论
    async queryComments() {
      this.vantList_IsLoading = true;
      let params = {
        page: this.page,
        limit: this.limit,
        module: this.module,
        id: this.id,
      };
      let { data } = await this.$api.queryComments(params);
      // data.forEach((item) => {
      //   item.is_thumb = 0;
      // });

      if (this.page == 1) {
        this.commentslist = data;
      } else {
        this.commentslist = this.commentslist.concat(data);
      }
      this.vantList_IsLoading = false;
      if (data.length < this.limit) {
        this.vantList_IsLoadOver = true;
      } else {
        this.vantList_IsLoadOver = false;
        this.page = this.page + 1;
      }
    },

    // 点击输入框，弹出输入弹框
    handleInput() {
      this.showPopup = true;
    },

    // 点击发送
    async handleSubmit() {
      if (this.comment.trim().length === 0) {
        this.$toast("请输入内容");
        return;
      }
      let data = {
        module: this.module,
        id: this.id,
        comment: this.comment,
      };
      await this.$api.publishComment(data);
      this.$toast("发送成功,审核通过后可见");
      this.comment = "";
      this.showPopup = false;
    },

    // 下拉加载
    onRefresh() {
      this.page = 1;
      this.queryComments();
      this.$toast("刷新成功");
      this.isDownLoading = false;
    },
    // 上划分页
    onUpRefreshLoad() {
      this.queryComments();
    },
  },

  created() {
    this.id = this.$route.query.id;
    this.module = this.$route.query.module;
    this.queryComments();
  },

  mounted() {},
};
</script>
<style lang="scss" scoped>
.comments_box {
  min-height: 100vh;
  width: 100%;
}
.comments {
  padding: 0 20px 60px;
  width: 100%;
  box-sizing: border-box;
}
/* 底部固定区 */
.footer_bar {
  z-index: 1000;
  display: flex;
  align-items: center;
  padding: 0 15px;
  box-sizing: border-box;
  position: fixed;
  bottom: 0;
  width: 375px;
  height: 55px;
  background-color: #ffffff;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
  input {
    flex: 1;
    height: 38px;
    background-color: #f6f6f6;
    border-radius: 38px;
    font-size: 14px;
    line-height: 38px;
    letter-spacing: 0.5px;
    color: #333333;
    box-sizing: border-box;
    outline: none;
    border: none;
    padding-left: 6px;
  }
}
.shuru {
  width: 90%;
  margin: 10px auto;
  .fasong {
    width: 50px;
    height: 30px;
    line-height: 30px;
    background-color: #e60012;
    border-radius: 10px;
    text-align: center;
    color: #fff;
    font-size: 14px;
    float: right;
    margin-top: 5px;
  }
  /deep/.van-cell {
    height: 100px;
    background-color: #e9e9e9;
    border-radius: 10px;
    /deep/.van-field__body {
      height: 90%;
    }
    /deep/.van-field__control {
      height: 90px !important;
      font-size: 14px;
      line-height: 20px;
    }
    /deep/.van-field__word-limit {
      font-size: 11px;
      margin-top: 0;
    }
  }
}
</style>
